<template>
  <section class="library-main-content index" v-if="library">
    <div class="inner">
      <div :class="{ open: isOpen }" class="main-filter-wrap">
        <div class="main-filter">
         <span class="text" v-if="!Object.keys(filtersObj).length">
           {{ $t('ALL_THE_CONTENTS') }}
         </span>
        </div>
      </div>
      <ul class="library-cards" v-if="collectionEntries && collectionEntries.length">
        <entry-card
          :collectionEntry="collectionEntry"
          :key="collectionEntry.data.id"
          v-for="collectionEntry in collectionEntries"
        >
        </entry-card>
      </ul>
      <div v-else>
                {{$t('NO_RESULTS_EXIST')}}
      </div>
    </div>
    <library-footer/>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import LibraryFooter from '@/components/library-footer.vue'
import EntryCard from '@/components/entry-card'

export default {
  components: { EntryCard, LibraryFooter },
  name: 'collection-view',
  data () {
    return {
      // opens and closes dropdown menu
      isOpen: false
    }
  },
  computed: {
    ...mapState({
      filtersObj: state => state.collections.filtersObj,
      collectionEntries: state => state.collections.collectionEntries,
      library: state => state.base.library
    }),
    ...mapGetters(['getClassificationByKey'])
  },
  methods: {
    getClassificationValueByKey (key, valueKey) {
      let selectedValue = this.getClassificationByKey(key)
      selectedValue = selectedValue.filter(v => v.id === parseInt(valueKey))[0]
      return selectedValue.value
    }
  }
}
</script>

<style scoped>

</style>
